/* ao criar esse enum, foi detectada uma duplicação de UserTypes,
inclusive no banco de dados. Isso precisa ser tratado no backend,
e enquanto isso não acontece, fica adicionado o id duplicado
entre parentes para poder haver distinção
*/
export enum UserTypes {
  "Gerente IH" = 1,
  "Coordenador IH" = 2,
  "Supervisor IH" = 3,
  "Atendente IH" = 4,
  "Moderador IH" = 5,
  "Comunicação IH" = 6,
  "Coordenador" = 8,
  "Supervisor" = 9,
  "Atendente" = 10,
  "Moderador" = 11,
  "Comunicação" = 12,
  "Administrativo IH" = 13,
  "Atendente(14)" = 14,
  "Atendente IH(15)" = 15,
  "BOT" = 7,
}

export type User = {
  photo: string;
  id: number;
  login: string;
  name: string;
  timeZone: string;
  nickName: string;
  document: string;
  email: string;
  active: boolean;
  allowForwardTicket: boolean;
  onlyManualAttribution: boolean;
  allowAssumeTickets: boolean;
  language: string;
  isPaused: boolean;
  createdAt: string;
  updatedAt: string;
  CompanyId: number | null;
  UserTypeId: UserTypes;
  enterKeySendsMessage: boolean | null;
};
